export enum ToolbarCustomButtonType {
  name = "name",
  link = "link",
}

export type ToolbarCustomButton = { type?: ToolbarCustomButtonType; component?: React.ReactNode };
